import { Action } from '../../actions';

export enum ParametersPageActionKeys {
	SET_USED_SPACE = '@@parametersPage/SET_USED_SPACE',
	SET_FREE_SPACE = '@@parametersPage/SET_FREE_SPACE',
}

interface SetUsedSpaceAction extends Action {
	type: ParametersPageActionKeys.SET_USED_SPACE;
	value: string;
}

interface SetFreeSpaceAction extends Action {
	type: ParametersPageActionKeys.SET_FREE_SPACE;
	value: string;
}

export type ParametersPageAction =
	| SetUsedSpaceAction
	| SetFreeSpaceAction;

export const setUsedSpace = (value: string): SetUsedSpaceAction => ({
	value,
	type: ParametersPageActionKeys.SET_USED_SPACE
});

export const setFreeSpace = (value: string): SetFreeSpaceAction => ({
	value,
	type: ParametersPageActionKeys.SET_FREE_SPACE
});


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ParametersPage/actions.ts